import React, { useState, useEffect } from 'react'
import '../App.css'
//import axios from 'axios';
import LoginRequest from './LoginRequest'
import { useParams } from 'react-router-dom'
/* import {
    SERVER_URI,
} from "../utility/config"; */

function RideReportsList(props) {
  props.stopListRefresh()
  const [show, setShow] = useState({})
  const [actualWorkShiftsList, setActualWorkShiftsList] = useState([])
  const [isloggedIn, setIsloggedIn] = useState(true)
  let storage = window.localStorage
  let userToken = storage.getItem('admin_token')
  let { driverId } = useParams()

  useEffect(() => {
    const fetchData = async () => {
      try {
        if (userToken === null) {
          console.log('kirjaudu sisään')
          setIsloggedIn(false)
        } else {
          if (props.listActualWorkShifts.length > 0) {
            setActualWorkShiftsList(props.listActualWorkShifts)
          }
        }
      } catch (exception) {
        console.log('Vuorojen noutaminen epäonnistui')
        console.log('Tämä on error:', exception)
      }
    }
    fetchData()
    // DON'T DELETE THE COMMENT BELOW!!
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])
  const toggleComment = (id) => {
    setShow((prevShow) => ({ ...prevShow, [id]: !prevShow[id] }))
  }

  function formatDate(string) {
    var options = {
      year: 'numeric',
      month: 'numeric',
      day: 'numeric',
      hour: 'numeric',
      minute: 'numeric',
    }
    return new Date(string).toLocaleString([], options)
  }

  return (
    <div>
      <span>
        <h2>Ajetut vuorot</h2>
        <p>Tähän tulee listaus kuljettajan ajamista työvuoroista </p>
        <div className='drivenShifts_listing'>
          {actualWorkShiftsList.length === 0 ? (
            <h4>Ei vuoroja</h4>
          ) : (
            actualWorkShiftsList
              .filter((shift) => Number(shift.driverId) === Number(driverId))
              .map((actualShift, index) => (
                <div
                  className='drivenShifts_list'
                  key={index}
                  id={actualShift.actualShiftId}
                  onClick={() => toggleComment(actualShift.actualShiftId)}
                >
                  {formatDate(actualShift.shiftStarts)}
                  <br />
                  <div
                    className={
                      show[actualShift.actualShiftId] ? 'showCar' : 'hide'
                    }
                  >
                    <span>Vuoro alkoi: </span>
                    <br className='mobile-break' />
                    {formatDate(actualShift.shiftStarts)}
                    <br />
                    <span>Vuoro loppui: </span>
                    <br className='mobile-break' />
                    {actualShift.shiftEnds === ''
                      ? ' Vuoro on käynnissä'
                      : formatDate(actualShift.shiftEnds)}
                    <br />
                    <span>Ajoneuvon Id:</span>
                    <br className='mobile-break' />
                    {actualShift.vehicleId}
                    <br />
                  </div>
                </div>
              ))
          )}
        </div>
      </span>
      {!isloggedIn && <LoginRequest />}
    </div>
  )
}

export default RideReportsList
